import { Hero } from "@/components/sections/hero";
import { FeaturedSection } from "@/components/sections/featured-section";

export function Home() {
  return (
    <div className="space-y-12">
      <Hero />
      <FeaturedSection />
    </div>
  );
}